import { PayloadAction } from '@reduxjs/toolkit';
import { CommonState, SnackbarState } from '../state';

export const sendRequest = (state: CommonState, _: PayloadAction) => {
    state.loading++;
}

export const receiveResponse = (state: CommonState, _: PayloadAction) => {
    state.loading--;
}

export const openDrawer = (state: CommonState, _: PayloadAction) => {
    state.drawer = true;
}

export const closeDrawer = (state: CommonState, _: PayloadAction) => {
    state.drawer = false;
}

export const openSnackbar = (state: CommonState, action: PayloadAction<SnackbarState>) => {
    state.snackbar = action.payload;
}

export const closeSnackbar = (state: CommonState, _: PayloadAction) => {
    state.snackbar.message = '';
}

export const signOut = (state: CommonState, _: PayloadAction) => {
    state.user = null;
}
